module.exports = __webpack_public_path__ + "static/media/search.478a4e2a.svg";